<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="goodslist_top">
        <div class="goodslist_title">筛选查询</div>
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            <el-col :span="8">
              <div class="goodslost_seach_row_col">
                <div>店铺名称:</div>
                <el-input placeholder="商品名称" v-model="filter_shop_name" style="width:190px" size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="goodslost_seach_row_col">
                <div>审核状态:</div>
                 <el-select v-model="filter_status" clearable placeholder="请选择">
                  <el-option
                    v-for="item in status_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="8" style="text-align:center">
              <div>
                <el-button size="small" @click="seach()">搜索</el-button>
                <el-button size="small" @click="change_null">清空</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>

            <div class="center_list_head_left_div">
              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <!-- <div class="show_total" @click="dialogFormVisible1 = true">添加用户</div> -->
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column align="center" prop="shop_name" label="店铺名称" width="120"></el-table-column>
        <el-table-column align="center" prop="uname" label="用户" width="180"></el-table-column>
        <el-table-column align="center" prop="mobile" label="联系电话" width="180"></el-table-column>
        <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">个人</span>
          <span v-else>企业</span>
        </template>
        </el-table-column>
        <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success">已审核</el-tag>   
          <el-tag v-else-if="scope.row.status == 2" type="warning">已驳回</el-tag>
          <el-tag v-else type="info">未审核</el-tag>
        </template>
        </el-table-column>
        <el-table-column align="center" prop="create_date" label="创建时间" width="180"></el-table-column>
  
        <el-table-column width="180" align="center" label="操作">
          <template slot-scope="scope">
            <span class="binaji" @click="review(scope.row.shop_id)">审核</span>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          class="goodslist_bom_page"
          hide-on-single-page
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pagechange"
        ></el-pagination>
        <!-- hide-on-single-page -->
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 查看申请信息并审核 -->
    <el-dialog
      title="查看入驻商信息"
      :visible.sync="dialogFormVisible1"
      width="30%">
        <el-form ref="ruleForm" label-width="145px" class="demo-ruleForm">
          <el-divider content-position="center">基本信息</el-divider>
          <el-form-item label="店铺名称:">
          <span>{{shopinfo.shop_name}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 1" label="姓名:">
          <span>{{shopinfo.uname}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="公司名称:">
          <span>{{shopinfo.uname}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="公司类型:">
          <span v-if="shopinfo.organ_type == 4">中外合资</span>
          <span v-else-if="shopinfo.organ_type == 3">外企</span>
          <span v-else-if="shopinfo.organ_type == 2">个体户</span>
          <span v-else>私营企业</span>
          </el-form-item>
           <!-- <el-form-item v-show="shopinfo.type == 2" label="组织机构代码:">
          <span>{{shopinfo.organ_type}}</span>
          </el-form-item> -->
          <el-form-item label="联系电话:">
          <span>{{shopinfo.mobile}}</span>
          </el-form-item>
          <el-form-item label="邮箱:">
          <span>{{shopinfo.email}}</span>
          </el-form-item>
          <el-form-item label="联系地址:">
          <span>{{shopinfo.addr}}</span>
          </el-form-item>
          <el-divider v-if="shopinfo.type == 1" content-position="center">身份证信息</el-divider>
          <el-divider v-else content-position="center">企业信息</el-divider>

          <el-form-item v-show="shopinfo.type == 1" label="身份证号:">
          <span>{{shopinfo.id_card}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="统一社会信用代码:">
          <span>{{shopinfo.organ_code}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="法定经营范围:">
          <span>{{shopinfo.organ_area}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 1" label="手持身份证照片:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.hand_card_img" 
                :preview-src-list="[serve + shopinfo.hand_card_img]">
              </el-image>
            </el-tooltip>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="企业营业执照:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.front_card_img" 
                :preview-src-list="[serve + shopinfo.front_card_img]">
              </el-image>
            </el-tooltip>  
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="法人身份证号:">
          <span>{{shopinfo.id_card}}</span>
          </el-form-item>
          <el-form-item v-show="shopinfo.type == 2" label="法人手持身份证照片:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.hand_card_img" 
                :preview-src-list="[serve + shopinfo.hand_card_img]">
              </el-image>
            </el-tooltip>  
          </el-form-item>
          <el-form-item  v-show="shopinfo.type == 1" label="身份证正面:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.front_card_img" 
                :preview-src-list="[serve + shopinfo.front_card_img]">
              </el-image>
            </el-tooltip>  
          </el-form-item>
          <el-form-item  v-show="shopinfo.type == 1" label="身份证反面:">
            <el-tooltip class="item" effect="dark" content="点击查看大图" placement="right-start">
              <el-image 
                style="width: 160px; height: 100%"
                :src="serve + shopinfo.back_card_img" 
                :preview-src-list="[serve + shopinfo.back_card_img]">
              </el-image>
            </el-tooltip>  
          </el-form-item>
          <el-form-item label="银行开户名:">
          <span>{{shopinfo.bank_uname}}</span>
          </el-form-item>
          <el-form-item label="银行账号:">
          <span>{{shopinfo.bank_card}}</span>
          </el-form-item>
          <el-form-item label="开户银行支行:">
          <span>{{shopinfo.bank_name}}</span>
          </el-form-item>
         
         <el-divider content-position="center">审核</el-divider>
          <el-form-item label="短信通知商家:">
           <el-checkbox v-model="isNotice"></el-checkbox>
          </el-form-item>
          <el-form-item label="平台使用费:">
           <!-- <el-input size="mini" width="20" class="useMoney" placeholder="请输平台使用费" v-model="platform_fee"  clearable></el-input> -->
           <el-input-number size="small" v-model="platform_fee" :precision="2" :step="10" :max="90000"></el-input-number>
          </el-form-item>
          <el-form-item label="保证金:">
          <!-- <el-input size="mini" width="20" class="useMoney" placeholder="保证金" v-model="promise_fee"  clearable></el-input> -->
          <el-input-number size="small" v-model="promise_fee" :precision="2" :step="10" :max="90000"></el-input-number>
          </el-form-item>
          <el-form-item label="分成利率:">
          <!-- <el-input size="mini" width="20" class="useMoney" placeholder="分成利率" v-model="share_rate"  clearable></el-input> -->
          <el-input-number size="small" v-model="share_rate" :precision="2" :step="0.1" :max="10"></el-input-number>
          </el-form-item>
          <el-form-item label="立即审核:">
              <el-radio  v-model="status" label="1">审核通过</el-radio>
              <el-radio  v-model="status" label="2">审核驳回</el-radio>
          </el-form-item>
          <el-form-item label="审核信息:">
            <el-input type="textarea" :rows="3" clearable placeholder="请输入审核信息" v-model="return_msg"></el-input>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitCheck">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      role: true, 
      serve: this.$store.state.serve,
      sy_name: "",
      loading: false,
      shop_name: "222",
      pass: "",
      pass1: "",
      company: "",
      product_number: "",
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 15,
      page: null,
      total: null,
      tableData: [],
      dialogFormVisible1: false,
      shopinfo: [],
      status: '1',
      return_msg: '',
      shop_id: 0,
      platform_fee: '',
      promise_fee: '',
      share_rate: '',
      filter_status: '',
      filter_shop_name: '',
      status_list: [{
          value: '4',
          label: '未审核'
        }, {
          value: '2',
          label: '审核驳回'
        }],
      isNotice: true  
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "入驻商申请";
    this.geting();
  },
  watch: {},
  methods: {
    review (id) {
      this.shop_id = id
      this.axios.get(this.serve + '/admin/shopReview',{
        params:{
          username: this.username,
          token: this.token,
          id: id
        }
      }).then(res=>{
        if(res.data.status == 'success'){
          this.status = res.data.data.status
          this.return_msg = res.data.data.return_msg
          this.platform_fee = res.data.data.platform_fee
          this.promise_fee = res.data.data.promise_fee
          this.share_rate = res.data.data.share_rate
          this.shopinfo = res.data.data;
          this.dialogFormVisible1 = true; 
        }
      })
    },
    submitCheck () { //审核店铺信息
        this.axios.get(this.serve + '/admin/checkShop',{
          params:{
            username: this.username,
            token: this.token,
            shop_id: this.shop_id,
            status: this.status,
            return_msg: this.return_msg,
            check_member: this.username,
            platform_fee: this.platform_fee,
            promise_fee: this.promise_fee,
            share_rate: this.share_rate,
            isNotice: this.isNotice
          }
        }).then(res=>{
            if(res.data.status == 'success'){
              this.$message.success(res.data.msg);
              this.dialogFormVisible1 = false
              this.geting()
            }else if(res.data.code == '403'){
              this.$message.error(res.data.msg);  
            }
        })
    },
    setgoods(id) {
      this.$router.push('/admin/shoplook/' + id)
    },
    seach() {
      this.geting();
    },
    change_null() {
      this.sy_name = "";
      this.geting();
    },
    pagechange(page) {
      this.geting(page);
    },
    change_page_num(v) {
      this.limit = v;
      this.geting();
    },
    addsubmit() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("shop_username", this.shop_name);
      formData.append("pass", this.pass);
      formData.append("pass2", this.pass1);
      formData.append("company", this.company);
      formData.append("product_number", this.product_number);
      this.axios
        .post(this.serve + "/admin/addShop", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.geting();
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.dialogFormVisible1 = false;
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/shopApplyList", {
          params: {
            username: this.username,
            token: this.token,
            page: page,
            limit: this.limit
          }
        })
        .then(res => {
          if(res.data.code == '403'){
            this.role = false;
          }else{         
            this.tableData = [];
            this.loading = false;
            if (res.data.status == "success") {
              this.page = res.data.data.page;
              this.total = res.data.data.total;
              this.tableData = res.data.data.results;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.el-form-item {
    margin-bottom: 5px;
}
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1022px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
  .useMoney{
    width: 148px;
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>